import { Http } from "../../../http";
import { WLP_SUBSCRIBE_NOLOGON } from "../../../config";

export interface WlpNoAuthStatisticResponse {
  Record: number[][];
  ActiveMinerCount?: number;
  Status?: "success" | "error";
  Message?: string;
}

const WlpStatisticPaths = {
  recentHashrate: WLP_SUBSCRIBE_NOLOGON
    ? "api/nologon/statistic"
    : "api/statistic",
} as const;

async function getRecentHashrate() {
  const response = await Http.request<WlpNoAuthStatisticResponse>({
    method: "GET",
    url: WlpStatisticPaths.recentHashrate,
  });

  return response.data;
}

export const wlpStatisticApi = {
  getRecentHashrate,
};
